module.exports = __webpack_public_path__ + "img/img2.c31a8061.jpg";